export const baseIp = 'https://api.dhzxkj.com/api/'

export const newsImg = 'https://pic.dhzxkj.com/'
